<template>
  <div class="dropdown-select" ref="dropdown">
    <div class="dropdown-selected" @click="toggleDropdown">
      <img class="icon" v-if="icon" :src="icon" alt="" />
      <div class="label-wrapper">
        <span v-if="showTitle">{{ selected ? selected.title : placeholder }}</span>
        <img class="arrow-down" :class="{ open: isOpen }" :src="arrowDownIcon" alt="" />
      </div>
    </div>
    <DropdownSelectMenu :open="isOpen" :value="value" :options="options" @select="select" />
  </div>
</template>

<script>
import DropdownSelectMenu from "./DropdownSelectMenu.vue";
export default {
  name: "DropdownSelect",
  components: { DropdownSelectMenu },
  props: {
    value: null,
    options: {
      type: Array,
      required: true,
    },
    icon: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    searchPlaceholder: {
      type: String,
      default: "",
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    selected() {
      return this.options.find(item => item.hid === this.value);
    },
    arrowDownIcon() {
      return require(`../../assets/common/arrow-down-1-on${this.darkModeImg}.png`);
    },
  },
  mounted() {
    document.addEventListener("click", this.closeDropdown);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeDropdown);
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    select(item) {
      this.isOpen = false;
      this.$emit("input", item.value);
      this.$emit("change", item);
    },
    closeDropdown(e) {
      if (!this.$refs.dropdown.contains(e.target)) {
        this.isOpen = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.dropdown-select {
  position: relative;
  width: fit-content;
  .dropdown-selected {
    display: flex;
    align-items: center;
    gap: 0 4px;
    background: var(--bg-60);
    border-radius: 20px;
    height: 32px;
    cursor: pointer;
    padding: 0 10px 0 4px;
    user-select: none;
    .icon {
      width: 24px;
      height: 24px;
    }

    .label-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0 10px;
      span {
        font-size: 12px;
        font-weight: 500;
        color: var(--color-7);
      }
      .arrow-down {
        width: 8px;
        height: 8px;
        transition: transform 0.3s;
        &.open {
          transform: rotate(180deg);
        }
      }
    }
  }
}
</style>
